const searchByFields = (array, fields, text) => {
  return array.filter(item => {
    return fields.some(field => {
      if (item[field]) {
        return item[field].toLowerCase().includes(text.toLowerCase())
      }
      return false
    })
  })
}

export { searchByFields }
